
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import AppButton from '@/components/Common/AppButton.vue';
import { useQuery } from '@vue/apollo-composable';
import { AbraWorkReport, GetAbraWorkReportDocument, Month } from '@/graphql/generated-operations';
import { formatTime } from '@/helpers/formatTime';

@Options({
  components: {
    AppButton,
  }
})
export default class ExportAbraWorkTable extends Vue {

  @Prop()
  month!: Month;

  loading = true;

  report: AbraWorkReport[] = [];

  created() {
    const { onResult: onDataResult } = useQuery(GetAbraWorkReportDocument, {
      month: this.month.key,
    });

    onDataResult(queryResult => {
      this.report = queryResult.data.getAbraWorkReport;

      this.loading = false;
    });
  }

  getTime(minutes: number)
  {
    return formatTime({
      hours: Math.floor(minutes / 60),
      minutes: minutes % 60,
    });
  }

}
